import DataLayerManager from "../trackers/dataLayer/dataLayerManager";

export default class SearchManager {
    constructor() {
        this.dataLayerManager = new DataLayerManager();
        this.eventDelegation();
    }

    eventDelegation() {
        document.querySelectorAll('[data-searcher-subchollo]').forEach((element) => {
            element.addEventListener('click', (event) => {
                this.createSubcholloBooking($(event.currentTarget));
            });
        })
    };

    createSubcholloBooking(elem) {
        let cholloId = elem.data('chollo-id');
        let cholloDateId = elem.data('date-id');
        let numOfPeople = elem.data('num-of-people');
        if (cholloId && cholloDateId && numOfPeople) {
            let datalayerParameters = {
                'cholloId': cholloId,
                'cholloDateId': cholloDateId,
                'numOfPeople': numOfPeople,
                'step': 2,
                'checkoutType': 'search'
            };

            this.dataLayerManager.push(DataLayerManager.prototype.type_checkout, datalayerParameters);
        }
    }
}
